var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackCrossIconModals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.728,
    height: 12.728,
    viewBox: "0 0 12.728 12.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2549",
    "data-name": "Group 2549",
    transform: "translate(6.364 -4.95) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y2: 16,
    transform: "translate(8 0)",
    fill: "none",
    stroke: "#5a5a5a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x1: 16,
    transform: "translate(0 8)",
    fill: "none",
    stroke: "#5a5a5a",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCrossIconModals);
export default __webpack_public_path__ + "static/media/BlackCrossIconModals.3b436fad981340f025254182a3be055b.svg";
export { ForwardRef as ReactComponent };